export default __webpack_public_path__ + "static/media/Fantasy_24.267bf290.png";